import axios, { ENDPOINT } from '../../../utils/httpClient'

export const register = (data) => {
    return axios.post(`${ENDPOINT}/registrations`, data)
}
